import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

const SubscriptionCancelAtPeriodEndConfirmationModal = observer(
  ({ t, selectedSubscriptionData, visible, hideModalCallback, cancelSubscriptionAtPeriodEndCallback }) => (
    <Modal open={visible} onClose={() => hideModalCallback()}>
      <Modal.Header>
        {t(
          `billingCentral:areYouSureYouWantTo${
            !selectedSubscriptionData.cancelAtPeriodEnd ? "Cancel" : "Reactivate"
          }TheSubscription`,
        )}
      </Modal.Header>
      {!selectedSubscriptionData.cancelAtPeriodEnd && (
        <Modal.Content>
          <p>
            {t("billingCentral:cancelSubscriptionConfirmationLine1", {
              endOfCurrentBillingCycleDate: selectedSubscriptionData.endOfCurrentBillingCycleDate,
            })}
          </p>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button secondary onClick={() => hideModalCallback()}>
          Cancel
        </Button>
        <Button
          primary
          onClick={() => {
            cancelSubscriptionAtPeriodEndCallback(!selectedSubscriptionData.cancelAtPeriodEnd);
            hideModalCallback();
          }}
        >
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  ),
);

SubscriptionCancelAtPeriodEndConfirmationModal.propTypes = {
  t: PropTypes.func.isRequired,
  selectedSubscriptionData: PropTypes.shape({
    id: PropTypes.number,
    cancelAtPeriodEnd: PropTypes.bool.isRequired,
    endOfCurrentBillingCycleDate: PropTypes.string.isRequired,
  }),
  visible: PropTypes.bool.isRequired,
  hideModalCallback: PropTypes.func.isRequired,
  cancelSubscriptionAtPeriodEndCallback: PropTypes.func.isRequired,
};

export default withTranslation()(SubscriptionCancelAtPeriodEndConfirmationModal);
